// extracted by mini-css-extract-plugin
export var container = "_sh-0";
export var inputWidth = "_sh-1";